import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
// 登录验证
export default new Vuex.Store({
    state: {
        user: false,
        getprovince: [], // 地址联动
        isShowNav: true,
        isShowNavCenter:true,
        gotRedPack: [],
        currentAddress: {},
        erweimaUrl: '',
        logo: "", //全局的logo
        list: [], //购物车的数据
        inquiryList:[],
        accountTotal: 0, // 购物车的金额
        totalNumber: 0, // 购物车数量
        loginData: {}, //登陆信息
        statusType: {},
        nickname:'',
        lastVisitPath:'',
        isPathSource:false
        // isBaselineVersion:false,
    },
    mutations: {
        //首页分类跳转
        getPathSource(state,param){
            state.isPathSource = param
        },
        getLastVisitPath(state,param){
            state.lastVisitPath = param
        },
        //用户昵称
        getNickname(state, param){
            state.nickname = param
        },
        //用户升级状态
        userStatusType(state, statusType) {
            state.statusType = statusType;
        },
        // 登录
        login(state, user) {
            state.user = user;
            localStorage.setItem("userdata", user);
            var exdate = new Date(); // 获取当前登录的时间
            exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * 0.5); // 三十分钟
            window.document.cookie = "userdata" + "=" + 1 + ";path=/;expires=" + exdate.toGMTString();// userdata等于1时登陆状态
        },
        // 退出
        logout(state, user) {
            state.user = "";
            localStorage.setItem("userdata", "");
        },
        // 地址
        getAddress(state, param) {
            state.getprovince = param
        },
        // 是否展示导航栏
        getisShowNav(state, param) {
            state.isShowNav = param
        },
        //是否展示搜索栏
        getisShowNavCenter(state, param){
            state.isShowNavCenter = param
        },
        //  已领取的 为了做对比,防止多次领取
        gotRedPackred(state, param) {
            console.log(state, param, '防止多次领取')
            state.gotRedPack = param
        },
        //  记录当前的位置
        gotCurrentAddress(state, param) {
            state.currentAddress = param
            console.log(state.currentAddress, '记录当前的位置')
        },
        // 获取微信二维码
        getWxerweima(state, param) {
            state.erweimaUrl = param
            console.log(state.erweimaUrl, '二维码')
        },
        //获取全局的logo
        getLogo(state, params) {
            state.logo = params.pcLogo
            console.log(state);
        },
        // 获取购物车内容
        getCartList(state, params) {
            console.log(state, params, '获取购物车内容')
            if (params.length == 0) {
                state.accountTotal = 0
            }
            state.list = params
            let newList = []
            params.forEach((x) => {
                x.bxunyouMerchant.goods.forEach((y) => {
                    newList.push(y)
                })
            })
            state.list = newList;
            let sum = 0
            state.accountTotal = 0
            sum = state.list.reduce((sum, item) => {
                if (item.cartSpecificationDetails != null) {
                    if (item.number > item.cartSpecificationDetails.stock) {
                        item.number = Number(item.cartSpecificationDetails.stock)
                    }
                }

                return sum + item.realprice * item.number; // 隐式转换             
            }, 0);
            let number = 0
            console.log(state.list, 'state.list')
            state.list.forEach((item) => {
                if (item.cartSpecificationDetails != null) {
                    if (item.number > item.cartSpecificationDetails.stock) {
                        item.number = Number(item.cartSpecificationDetails.stock)

                    } else if (item.cartSpecificationDetails.stock == 0 && item.number == 0) {
                        item.number = 1
                    }
                }

                number += item.number
            })
            state.totalNumber = number
            state.accountTotal += sum;
        },
        getInquiryList(state, params){
            state.inquiryList = params
        },
        
        //存注册信息
        setLoginData(state, loginData) {
            state.loginData = loginData;
            sessionStorage.setItem('loginData', JSON.stringify(loginData))
        },
        getfoodnavY(state,params){
            state.foodnavY = params;
        }
    }
})


// WEBPACK FOOTER //
// ./src/vuex/store.js